Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleEngine = void 0;
const variant_1 = require("./variant");
const strategy_1 = require("./client/strategy");
const variant_2 = require("./variant");
function processFeatures(rawFeatures) {
    const processedFeatures = new Map();
    if (rawFeatures) {
        rawFeatures.features.forEach((feature) => {
            processedFeatures.set(feature.name, feature);
        });
    }
    return processedFeatures;
}
function processSegments(rawFeatures) {
    const processedSegments = new Map();
    if (rawFeatures && rawFeatures.segments) {
        rawFeatures.segments.forEach((segment) => {
            processedSegments.set(segment.id, segment);
        });
    }
    return processedSegments;
}
class ToggleEngine {
    features;
    strategies;
    segments;
    constructor(rawFeatures) {
        this.features = processFeatures(rawFeatures);
        this.strategies = [...strategy_1.defaultStrategies];
        this.segments = processSegments(rawFeatures);
    }
    getStrategy(name) {
        return this.strategies.find((strategy) => strategy.name === name);
    }
    *yieldConstraintsFor(strategy) {
        if (strategy.constraints) {
            yield* strategy.constraints;
        }
        const segments = strategy.segments?.map((segmentId) => this.segments.get(segmentId));
        if (!segments) {
            return;
        }
        yield* this.yieldSegmentConstraints(segments);
    }
    yieldSegmentConstraints(segments) {
        let constraints = [];
        for (const segment of segments) {
            if (segment) {
                constraints = constraints.concat(segment.constraints);
            }
            else {
                constraints.push(undefined);
            }
        }
        return constraints;
    }
    getValue(name, context) {
        let strategyVariant = undefined;
        const feature = this.features.get(name);
        if (!feature?.enabled) {
            return undefined;
        }
        const hasEnabledStrategy = feature?.strategies?.some((strategySelector) => {
            const strategy = this.getStrategy(strategySelector.name);
            if (!strategy) {
                return false;
            }
            const constraints = this.yieldConstraintsFor(strategySelector);
            const result = strategy.getResult(strategySelector.parameters, context, constraints, strategySelector.variants);
            if (result.enabled) {
                strategyVariant = result.variant;
                return true;
            }
            return false;
        });
        if (strategyVariant) {
            return strategyVariant;
        }
        if (feature?.variants) {
            const featureVariant = (0, variant_1.selectVariant)(feature, context);
            if (featureVariant) {
                return {
                    name: featureVariant.name,
                    payload: featureVariant.payload,
                    enabled: true,
                };
            }
        }
        if (hasEnabledStrategy || !feature?.strategies?.length) {
            return (0, variant_2.getDefaultVariant)();
        }
        return undefined;
    }
}
exports.ToggleEngine = ToggleEngine;
